import { port_optim_actions, port_optim_metrics_actions, port_optim_exposure_actions } from './ActionType';

export const OptimSaa = (state = {
        isLoading: false,
        errMess: null,
        data: null
    }, action) => {
    switch(action.type){
        case port_optim_actions.add:
            return {...state, isLoading: false, errMess: null, data: action.payload};
        case port_optim_actions.loading:
            return {...state, isLoading: true, errMess: null, data:null};
        case port_optim_actions.failed:
            return {...state, isLoading: false, errMess: action.payload, data:null};
        case port_optim_actions.reset:
            return {...state, isLoading: false, errMess: null, data:null};
        case port_optim_actions.reset_err:
            return {...state, isLoading: false, errMess: null, data:null};
        case port_optim_actions.udt_port:
          return {...state, errMess: null,  isLogging: false, data: {
              ...state.data,
              port: action.payload
            },
          };
        default:
            return state;
    }
};

export const SaaMetrics = (state = {
        isLoading: false,
        errMess: null,
        data: null
    }, action) => {
    switch(action.type){
        case port_optim_metrics_actions.add:
            return {...state, isLoading: false, errMess: null, data: action.payload};
        case port_optim_metrics_actions.loading:
            return {...state, isLoading: true, errMess: null, data:null};
        case port_optim_metrics_actions.failed:
            return {...state, isLoading: false, errMess: action.payload, data:null};
        case port_optim_metrics_actions.reset:
            return {...state, isLoading: false, errMess: null, data:null};
        case port_optim_metrics_actions.reset_err:
            return {...state, isLoading: false, errMess: null, data:null};
        default:
            return state;
    }
};

export const SaaExposure = (state = {
        isLoading: false,
        errMess: null,
        data: null
    }, action) => {
    switch(action.type){
        case port_optim_exposure_actions.add:
            return {...state, isLoading: false, errMess: null, data: action.payload};
        case port_optim_exposure_actions.loading:
            return {...state, isLoading: true, errMess: null, data:null};
        case port_optim_exposure_actions.failed:
            return {...state, isLoading: false, errMess: action.payload, data:null};
        case port_optim_exposure_actions.reset:
            return {...state, isLoading: false, errMess: null, data:null};
        case port_optim_exposure_actions.reset_err:
            return {...state, isLoading: false, errMess: null, data:null};
        default:
            return state;
    }
};
